/**
 * Settings Service
 * 
 * API service for user settings management
 */

import { apiClient } from './apiService';

/**
 * Get user settings
 */
export const getSettings = async (userId) => {
  try {
    const response = await apiClient.get(`/settings/${userId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching settings:', error);
    throw error;
  }
};

/**
 * Update user settings
 */
export const updateSettings = async (userId, updateData) => {
  try {
    const response = await apiClient.put(`/settings/${userId}`, updateData);
    return response.data;
  } catch (error) {
    console.error('Error updating settings:', error);
    throw error;
  }
};

/**
 * Change password
 */
export const changePassword = async (userId, passwordData) => {
  try {
    const response = await apiClient.post(`/settings/${userId}/password`, passwordData);
    return response.data;
  } catch (error) {
    console.error('Error changing password:', error);
    throw error;
  }
};

/**
 * Add active session
 */
export const addSession = async (userId, sessionData) => {
  try {
    const response = await apiClient.post(`/settings/${userId}/sessions`, sessionData);
    return response.data;
  } catch (error) {
    console.error('Error adding session:', error);
    throw error;
  }
};

/**
 * Remove specific session
 */
export const removeSession = async (userId, sessionId) => {
  try {
    await apiClient.delete(`/settings/${userId}/sessions/${sessionId}`);
    return true;
  } catch (error) {
    console.error('Error removing session:', error);
    throw error;
  }
};

/**
 * Remove all sessions (except current)
 */
export const removeAllSessions = async (userId, exceptCurrent = true) => {
  try {
    await apiClient.delete(`/settings/${userId}/sessions`, {
      params: { except_current: exceptCurrent }
    });
    return true;
  } catch (error) {
    console.error('Error removing all sessions:', error);
    throw error;
  }
};

/**
 * Get current user's crawler API keys (masked). Requires auth (Bearer token).
 */
export const getApiKeys = async () => {
  const response = await apiClient.get('/settings/me/api-keys');
  return response.data;
};

/**
 * Update current user's crawler API keys. Only provided keys are updated; empty string clears.
 * Requires auth (Bearer token).
 */
export const updateApiKeys = async (data) => {
  const response = await apiClient.put('/settings/me/api-keys', data);
  return response.data;
};

